import { useState } from "react";
import EditIcon from "@mui/icons-material/Edit";
import { Modal } from "@mui/material";
import EditUserModal from "./EditUserModal";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import RestoreIcon from "@mui/icons-material/Restore";
import { Button } from "@mui/material";
import ResetUserModal from "./ResetUserModal";
import DeleteIcon from "@mui/icons-material/Delete";
import DeleteUserModal from "./DeleteUserModal";
import LogsModal from "../AssetManagement/LogsModal";
import TableRowsIcon from "@mui/icons-material/TableRows";

export default function IndvUser({ user, accessLevels, refreshUsers }) {
  //Modals
  const [openUpdateUser, setOpenUpdateUser] = useState(false);
  const [openReset, setOpenReset] = useState(false);
  const [openDeleteUser, setOpenDeleteUser] = useState(false);
  const [openLogs, setOpenLogs] = useState(false);

  return (
    <>
      <tr
        style={
          user.blocked
            ? { backgroundColor: "#ffc3c3" }
            : { backgroundColor: "#fff" }
        }
      >
        <td>{user.userName}</td>
        <td>{user.email}</td>
        <td>{user.levelType}</td>
        <td>
          <Tooltip title="reset user access">
            <Button
              variant="contained"
              color={user.blocked ? "error" : "warning"}
              onClick={() => setOpenReset(true)}
            >
              <RestoreIcon />
            </Button>
          </Tooltip>
        </td>
        <td>
          <Tooltip title="Edit User">
            <IconButton>
              {" "}
              <EditIcon
                fontSize="large"
                color="warning"
                onClick={() => {
                  setOpenUpdateUser(true);
                }}
                sx={{ cursor: "pointer" }}
              />
            </IconButton>
          </Tooltip>
        </td>
        <td>
          <Tooltip title="Delete User">
            <IconButton
              onClick={() => {
                setOpenDeleteUser(true);
              }}
            >
              <DeleteIcon fontSize="large" color="error" />
            </IconButton>
          </Tooltip>
        </td>
        <td>
          <Tooltip title="Access Asset Logs">
            <IconButton onClick={() => setOpenLogs(true)}>
              <TableRowsIcon color="primary" />
            </IconButton>
          </Tooltip>
        </td>
      </tr>
      {/* /MODALS */}
      <Modal open={openUpdateUser}>
        <EditUserModal
          user={user}
          accessLevels={accessLevels}
          handleClose={setOpenUpdateUser}
          refreshUsers={refreshUsers}
        />
      </Modal>
      <Modal open={openDeleteUser}>
        <DeleteUserModal
          userId={user.userId}
          handleClose={setOpenDeleteUser}
          refreshUsers={refreshUsers}
          username={user.userName}
        />
      </Modal>
      <Modal open={openReset}>
        <ResetUserModal
          userId={user.userId}
          username={user.userName}
          handleClose={setOpenReset}
          refreshUsers={refreshUsers}
          email={user.email}
        />
      </Modal>
      <Modal open={openLogs}>
        <LogsModal
          userId={user.userId}
          handleClose={setOpenLogs}
          logsType="user"
        />
      </Modal>
    </>
  );
}
